import { useState, useEffect } from "react";
import OtpInput from "react-otp-input";
import logo from "../../Assets/images/logo.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { authService } from "../../services/authServices";
import { toast } from "react-toastify";

export const OtpVerification = () => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState("");
  const [errors, setErrors] = useState({});
  const [resendTimer, setResendTimer] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const email = queryParams.get("email");
  const type = queryParams.get("type");

  const fetchResendTimeout = async () => {
    try {
      const response = await authService.resendTimeout(email);

      const otpResendAt = response?.data?.otp_resend_at;
      if (otpResendAt) {
        const targetTime = new Date(otpResendAt).getTime();
        const now = Date.now();
        const diffSeconds = Math.max(0, Math.floor((targetTime - now) / 1000));
        setResendTimer(diffSeconds);
      } else {
        setErrors((prev) => ({
          ...prev,
          api: "You have exceeded the maximum number of OTP attempts. Please contact the administrator for assistance.",
        }));
      }
    } catch (error) {
      console.error("Failed to fetch resend timeout:", error);
    }
  };

  useEffect(() => {
    let interval;
    if (resendTimer > 0) {
      interval = setInterval(() => {
        setResendTimer((prev) => Math.max(0, prev - 1));
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [resendTimer]);

  useEffect(() => {
    if (type === "signup") {
      fetchResendTimeout();
    }
  }, [type]);

  const validateForm = () => {
    const newErrors = {};
    if (!otp || otp.length !== 6 || isNaN(otp)) {
      newErrors.otp = "Invalid OTP";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (value) => {
    setOtp(value);
    if (errors.otp) {
      setErrors((prev) => ({ ...prev, otp: "" }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    try {
      if (type === "forgot-password") {
        const response = await authService.verifyOtp(email, otp);
        if (response.status === "ok" || response.code === 200) {
          navigate(`/reset-password?email=${email}`);
        }
      } else if (type === "signup") {
        const response = await authService.verifyCode(email, otp);
        if (response.status === "ok" || response.code === 200) {
          navigate(`/thank-you`);
        }
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      toast.error(errorMessage);
    }
  };

  const handleResendOtp = async (e) => {
    e.preventDefault();
    if (resendTimer > 0) return;

    try {
      if (type === "forgot-password") {
        const response = await authService.forgotPassword(email);
        if (response.status === "ok" || response.code === 200) {
          toast.success("OTP sent successfully");
        }
      } else if (type === "signup") {
        const response = await authService.resendCode(email);
        if (response.status === "ok" || response.code === 200) {
          if (!errors.api) {
            toast.success("OTP sent successfully");
          }
          fetchResendTimeout();
        }
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message;
      toast.error(errorMessage);
    }
  };

  return (
    <>
      <div className="main min-vh-100 d-flex justify-content-center flex-row w-100 authmain">
        <div className="authcard">
          <div className="w-100 text-center">
            <Link to="" className="authlogo">
              <img src={logo} width={337} height={90} alt="logo" />
            </Link>
          </div>
          <div className="authcardmain">
            <div className="authcardheader">
              <span className="h_2 white-font fw-medium ">
                OTP Verification
              </span>
            </div>
            <form className="authform" onSubmit={handleSubmit}>
              <div className="form-group otp-input-wrapper mb-4">
                <OtpInput
                  value={otp}
                  onChange={handleInputChange}
                  numInputs={6}
                  renderSeparator={<span>-</span>}
                  renderInput={(props) => <input {...props} />}
                  inputType="tel"
                />
                {errors.otp && (
                  <span className="required-text">{errors.otp}</span>
                )}
              </div>
              <button type="submit" className="btn-primary-custom w-100">
                Continue
              </button>
              <div className="d-flex align-items-center mt-4 justify-content-center flex-column">
                {/* {type === "forgot-password" ? (
                  <span className="font-12 fw-normal white-font">
                    Don’t receive code?{" "}
                    <a
                      className="primary-font cursor-pointer"
                      onClick={handleResendOtp}
                    >
                      Resend
                    </a>
                  </span>
                ) : type === "signup" ? (
                  !errors.api && (
                    <span className="font-12 fw-normal white-font">
                      Don’t receive code?{" "}
                      {resendTimer > 0 ? (
                        <span className="primary-font">
                          {Math.floor(resendTimer / 60)}:
                          {String(resendTimer % 60).padStart(2, "0")}
                        </span>
                      ) : (
                        <a
                          className="primary-font cursor-pointer"
                          onClick={handleResendOtp}
                        >
                          Resend
                        </a>
                      )}
                    </span>
                  )
                ) : null} */}
                {!errors.api && (
                  <span className="font-12 fw-normal white-font">
                    Don’t receive code?{" "}
                    {resendTimer > 0 ? (
                      <span className="primary-font">
                        {Math.floor(resendTimer / 60)}:
                        {String(resendTimer % 60).padStart(2, "0")}
                      </span>
                    ) : (
                      <a
                        className="primary-font cursor-pointer"
                        onClick={handleResendOtp}
                      >
                        Resend
                      </a>
                    )}
                  </span>
                )}
                {errors.api && (
                  <span className="required-text mt-2">{errors.api}</span>
                )}
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};
